class Nouvelles
{
    constructor()
    {
        this.postsPerPage = 0;
        this.currentIndex = 1;
        this.totalPosts = 0;
        this.maxIndex = 0;
        this.init();
    }

    init()
	{
        this.postsPerPage = document.querySelector(".row_liste_nouvelles .items-container").dataset.postsperpage;
        this.totalPosts = document.querySelector(".row_liste_nouvelles .items-container").dataset.total;
        this.maxIndex = Math.ceil(this.totalPosts / this.postsPerPage) - 1;

        document.querySelector(".plus").addEventListener("click", (e) =>
        {
            e.preventDefault();

            if (this.currentIndex <= this.maxIndex) {
                fetch(`/wp-json/wp/v2/posts?page=${this.currentIndex + 1}&per_page=${this.postsPerPage}&_embed`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(posts => {
                    let container = document.querySelector('.items-container');
                    posts.forEach(post => {
                        let postElement = document.createElement('div');
                        postElement.classList.add('item');

                        let author = post._embedded.author[0].name;
                        let date = post.date;

                        let dateObj = new Date(date);
                        let options = { year: 'numeric', month: 'long', day: 'numeric' };
                        date = dateObj.toLocaleDateString('fr-FR', options);

                        let content = post.excerpt.rendered;

                        if(content == "") {
                            let acf = post.acf;
                            if(acf.page_rows[1]) {
                                content = acf.page_rows[1].row_texts[0].text_content;
                                content = content.replace(/<[^>]*>?/gm, '');

                                if (content.length > 300) {
                                    content = content.substring(0, 300) + ' [...]';
                                }
                            } else if(acf.page_rows[0]) {
                                content = acf.page_rows[0].row_texts[0].text_content;
                                content = content.replace(/<[^>]*>?/gm, '');

                                if (content.length > 300) {
                                    content = content.substring(0, 300) + ' [...]';
                                }


                            }
                        }
                        
                        let lang = document.documentElement.lang;
                        let enSavoirPlus = "En savoir plus";
                        if(lang == "en-US") {
                            enSavoirPlus = "Learn more";
                            date = dateObj.toLocaleDateString('en-US', options);
                        }

                        postElement.innerHTML = `
                            <div class="item-container">
                                <canvas class="hexagone hexa-3" width="300" height="300" data-bgcolor="white"></canvas>
                                <div class="item-content">
                                    <div class="item-title">
                                        <h3><a href="${post.link}">${post.title.rendered}</a></h3>
                                    </div>
                                    <div class="item-text">
                                        <p>${content}</p>
                                        <a class="btn" href="${post.link}">${enSavoirPlus}</a>
                                    </div>
                                    <div class="etiquette text-top">
                                        <canvas class="hexagone hexa-1-3" width="300" height="300" data-scale="small" data-scale_mobile="small" data-bgcolor="yellow"></canvas>
                                        <span>${author} | ${date}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                        container.appendChild(postElement);
                        window.dispatchEvent(new Event('resize'));
                    });

                    let btnHover = gsap.utils.toArray(".btn");
                    btnHover.forEach(btn =>
                    {
                        if(btn.querySelector(".label-in") !== null) return;
                        let label = btn.innerHTML;
                        btn.innerHTML = "<span class='label-in'>" + label + "</span><span class='label-out'>" + label + "</span>";
                        btn.classList.add("btn-hover");
                        
                        btn.addEventListener("mouseenter", function(e)
                        {
                            gsap.to(btn.querySelector(".label-in"), {duration:1, yPercent:-100, ease:"expo.out", overwrite:true});
                            gsap.to(btn.querySelector(".label-out"), {duration:1, yPercent:-100, ease:"expo.out", overwrite:true});
                        });

                        btn.addEventListener("mouseleave", function(e)
                        {
                            gsap.to(btn.querySelector(".label-in"), {duration:0.8, yPercent:0, ease:"expo.out", overwrite:true});
                            gsap.to(btn.querySelector(".label-out"), {duration:0.8, yPercent:0, ease:"expo.out", overwrite:true});
                        });
                    });

                    let blocs = gsap.utils.toArray(".row_liste_nouvelles .item .item-container");
                    blocs.forEach(bloc => {
                        if(bloc.style.visibility == "") {
                            gsap.set(bloc, {transformStyle: "preserve-3d", transformOrigin: "50% 0%"});
                            gsap.from(bloc, {
                                autoAlpha:0,
                                duration:1,
                                y:50,
                                z:0,
                                rotationX: -20, 
                                ease:"power3.out",
                                scrollTrigger: {
                                    invalidateOnRefresh: false,
                                    trigger:bloc,
                                    start:"center 90%",
                                    toggleActions: "play none play none"
                                },
                            });
                        }
                    });

                    let textsTop = gsap.utils.toArray(".text-top");
                    textsTop.forEach(textTop => {
                        if(textTop.style.visibility == "") {
                            gsap.from(textTop, {
                                autoAlpha:0,
                                duration:1,
                                y:20,
                                ease:"power3.out",
                                scrollTrigger: {
                                    trigger:textTop,
                                    start:"top 90%",
                                    toggleActions: "play none play none"
                                }
                            });
                        }
                    });

                    this.currentIndex++;
                    if (this.currentIndex > this.maxIndex) {
                        document.querySelector(".plus").style.display = 'none';
                    }
                })
                .catch(error => console.error('Error:', error));
            }                    
	    });
    }
}

export default Nouvelles;